// extracted by mini-css-extract-plugin
export var askAiIcon = "_ol-k";
export var category = "_ol-a";
export var categoryHeader = "_ol-f";
export var container = "_ol-0";
export var group = "_ol-b";
export var groupItems = "_ol-g";
export var groupSeparator = "_ol-l";
export var highlight = "_ol-8";
export var loading = "_ol-1";
export var noResults = "_ol-3";
export var placeholder = "_ol-2";
export var resultContent = "_ol-5";
export var resultIcon = "_ol-d";
export var resultItem = "_ol-h";
export var resultMeta = "_ol-9";
export var resultSubtitle = "_ol-7";
export var resultSuffix = "_ol-j";
export var resultTitle = "_ol-6";
export var resultsList = "_ol-4";
export var searchGroup = "_ol-e";
export var selected = "_ol-i";
export var subgroup = "_ol-c";